const lang = {
  title: 'アカウント',
  change: '変更',
  accountInfo: 'アカウント情報',
  accountName: 'アカウント名',
  emailAddress: 'メール<br>アドレス',
  password: 'パスワード',
  contractInfo: 'ご契約情報',
  plan: 'プラン',
  personal: 'パーソナル',
  companyName: '会社名',
  postalCode: '郵便番号',
  streetAddress: '住所',
  buildingName: '建物名',
  representativeName: '代表者名',
  PIC: 'ご担当者名',
  departmentName: '部署名',
  phoneNumber: '電話番号',
  contractPeriod: '契約期間',
  confirmedAfterDeposit: '入金後に確定',
  changingPlan: '有料アカウントは全機能が無制限！',
  freeAccount: '無料アカウント',
  paidAccount: '有料アカウント',
  trialAccount: 'トライアルアカウント',
  usageCharges: '利用料',
  free: '¥0',
  price: '¥26,400/年<br>（月額¥2,200）',
  numberOfCases: '案件数',
  oneCase: '1案件',
  unlimited: '無制限',
  itemStoragePeriod: '案件保管期間',
  tenDays: '10日間',
  collaboration: '共同作業',
  createReport: '報告書作成',
  watermarkIncluded: 'ZENGO </br> ロゴ入り',
  submissionReport: 'ZENGO </br> ロゴなし',
  note: '※金額は税込みです。※支払い方法は請求書払いです。',
  changeContractInfo: 'ご契約情報の変更をご希望される場合は',
  inquiryForm: 'お問い合わせフォーム',
  contactUs: 'よりご連絡ください。',
  paidAccountApplication: '有料アカウント申込み',
  iconNotChanged: 'アイコン変更されていません。',
  updated: '更新しました。',
  passwordUpdated: 'パスワードが変更されました。',
  modalAccountName: {
    title: 'アカウント名変更',
  },
  modalPassword: {
    title: 'パスワード変更',
    currentPassword: '現在のパスワード',
    forgotPassword: 'パスワードがわからない方はこちら',
    newPassword: '新しいパスワード',
    passwordTip: '６～２０文字の半角の英数字または記号で入力してください。英字と数字の両方を含めてください。',
    retypePassword: '新しいパスワード再入力',
  },
  modalEmail: {
    title: 'メールアドレス変更',
    newEmail: '新しいメールアドレス',
    newEmailConfirm: '新しいメールアドレス（確認用）',
    sendConfirmEmail: '確認メールを送付',
    sentEmail: '確認メール送信が完了しました。'
  },
  emailChanged: {
    emailChanged: 'メールアドレス変更が完了しました。',
    toAccountPage: 'アカウントページへ',
  },
  adminAccount: '管理者アカウント',
  supervisorAccount: '監督者アカウント',
  operatorAccount: '作業者アカウント'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/account.js